import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalHeader
} from "reactstrap"
import i18n from "../../../i18n"

import Step1 from "./Step1";
import Step2 from "./Step2";

const GroupDestinationRoutingModal = (props) => {

  const { isOpen, toggle, setShowModalDestination, setGroupDestinationRoutingModal, listModifyRouting, setSelectedRoutingDestination } = props;

  const [step, setStep] = useState(1);
  const [selectRouting, setSelectRouting] = useState(null);

  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="GroupDestinationRoutingModal"
      tabIndex="-1"
      toggle={toggle}
      backdrop={'static'}
      id="staticBackdrop"
      size="xl"
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>{i18n.t("GroupDestination")}</ModalHeader>
        {(() => {
            switch(step) {
              case 1:
                return <Step1
                         listModifyRouting={listModifyRouting}
                         setSelectRouting={setSelectRouting}
                         setGroupDestinationRoutingModal={setGroupDestinationRoutingModal}
                         setStep={setStep}></Step1>
              case 2:
                return <Step2
                         setShowModalDestination={setShowModalDestination}
                         setSelectRouting={setSelectRouting}
                         setSelectedRoutingDestination={setSelectedRoutingDestination}
                         setGroupDestinationRoutingModal={setGroupDestinationRoutingModal}
                         selectRouting={selectRouting}
                         toggle={toggle}
                         setStep={setStep}></Step2>
            }
        })()}
      </div>
    </Modal>
  )
}

GroupDestinationRoutingModal.propTypes = {
  GroupDestinationRoutingModal: PropTypes.func,
  setShowModalDestination: PropTypes.func,
  toggle: PropTypes.func,
  setSelectedRoutingDestination: PropTypes.func,
  isOpen: PropTypes.bool
}

export default GroupDestinationRoutingModal;

